var $7c4f4e5bb7c06f1e$exports = {};
$7c4f4e5bb7c06f1e$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "F\xE4rgv\xE4ljaren",
  "colorSwatch": "f\xE4rgruta",
  "transparent": "genomskinlig",
  "twoDimensionalSlider": "2D-reglage"
};
export { $7c4f4e5bb7c06f1e$exports as default };